const SettlementEmptyMessage = ({ name, onClick }) => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center w-100 m-t-5"
      style={{
        backgroundColor: "var(--primary-15)",
        color: "var(--primary)",
        textTransform: "uppercase",
        width: "206px",
        minHeight: "195px",
        cursor: onClick ? "pointer" : "default",
        marginBottom: name === "TRUST LEDGER" ? "5px" : "0px",
      }}
      onClick={onClick}
    >
      <span>NO {name} ADDED.</span>
      <span>CLICK TO ADD</span>
    </div>
  );
};

export default SettlementEmptyMessage;
